/**
 * RatingListContainer
 * --
 */
import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import RatingListPresenter from './RatingListPresenter';
import { useGetGrades, gradeQueryKeys } from 'hooks/GradeHooks';
import { useGetCoupons } from 'hooks/CouponHooks';
import { useGetSetting } from 'hooks/SettingHooks';

const SEARCH_VALUE = {
  user_name: '',
  membership_code: '',
  user_account: '',
  user_phone: '',
  user_email: '',
};
const RatingListContainer = () => {
  /* ===== ROUTE ===== */
  const queryClient = useQueryClient();
  /* ===== PROPS ===== */
  /* ===== Data ===== */
  const options = {
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return [];

      return data;
    },
    initialData: [],
  };
  const { data: Grades } = useGetGrades(
    {
      join_tables: '["user"]',
    },
    options
  );
  const { data: Coupons } = useGetCoupons(null, options);
  const { data: GradeSetting } = useGetSetting(1, null, {
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return null;

      return data.grade_setting;
    },
    initialData: null,
  });

  /* ===== STATE ===== */
  const [isLoading, setIsLoading] = React.useState(false);
  const [isOpened, setIsOpened] = React.useState(null);
  const [searchValue, setSearchValue] = React.useState(SEARCH_VALUE);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 바인딩 함수
   * ---
   */
  const handleChangeSearchValue = (t, v) => {
    setSearchValue((prev) => ({
      ...prev,
      [t]: v,
    }));
  };

  const handleResetSearchValue = () => {
    setSearchValue(SEARCH_VALUE);
  };

  /**
   * 데이터 최신화
   * --
   */
  const handleReload = () => {
    const queryKey = gradeQueryKeys.getGrades({
      join_tables: '["user"]',
    });
    queryClient.invalidateQueries({ queryKey: queryKey.queryKey });
  };
  /* ===== HOOKS ===== */

  /**
   * 등급 데이터 정제
   * --
   */
  const GradeData = React.useMemo(() => {
    if (!Grades.length) return [];
    const newData = Grades.map((grade) => ({
      key: grade.grade_id,
      ...grade,
      couponList: grade.coupon
        ? Object.values(
            grade.coupon.reduce((acc, coupon) => {
              const existingCoupon = acc[coupon.coupon_id];

              if (existingCoupon) {
                existingCoupon.num = (existingCoupon.num || 1) + 1;
              } else {
                acc[coupon.coupon_id] = {
                  key: coupon.coupon_id,
                  num: 1, // 초기값 설정
                  ...coupon,
                  ...(Coupons.length &&
                    Coupons.find((c) => c.coupon_id === coupon.coupon_id)),
                };
              }

              return acc;
            }, {})
          )
        : [],
    }));

    return newData;
  }, [Grades, Coupons]);

  /* ===== RENDER ===== */
  return (
    <>
      <RatingListPresenter
        grades={GradeData}
        coupons={Coupons}
        setting={GradeSetting}
        isLoading={isLoading}
        isOpened={isOpened}
        setIsOpened={setIsOpened}
        setIsLoading={setIsLoading}
        onChangeSearchValue={handleChangeSearchValue}
        searchValue={searchValue}
        onResetSearchValue={handleResetSearchValue}
        onReload={handleReload}
      />
    </>
  );
};

export default RatingListContainer;
